/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import styled from 'styled-components';

import moment from 'moment';
import { ListingLabelContext } from 'contexts';

interface Listing {
  id: string;
  line1: string;
  line2?: string;
  city: string;
  province: string;
  postalCode: string;
  listPrice: number;
  neighborhood: string;
  county?: string;
  status: string;
  type: string;
  dom: number;
  availability: string;
  expiry: Date;
  agents: string[];
}

function SingleListing(
  listing: Listing,
  gridListing: object,
  divStyle: object,
) {
  const expiry = moment(listing.expiry).format('MMM Do, YYYY');
  const price = `$${new Intl.NumberFormat('en-CA').format(listing.listPrice)}`;
  const longAddress = `${listing.city} ${listing.province} ${listing.postalCode}`;
  const wrapTextStyles = {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  const { getLabel, getAvailability } = React.useContext(ListingLabelContext);
  const displayedField =
    getLabel('Neighborhood Display')?.trim().toUpperCase() === 'COUNTY'
      ? 'county'
      : 'neighborhood';

  return (
    <div className="content-block" style={gridListing} key={listing.id}>
      <div style={divStyle}>
        <div style={wrapTextStyles}>
          {listing.line1}
          {listing.line2}
        </div>
        <div style={{ fontSize: '0.8em', ...wrapTextStyles }}>
          {longAddress}
        </div>
      </div>
      <div style={divStyle}>{price}</div>
      <div style={{ ...divStyle, ...wrapTextStyles }}>
        {listing[displayedField]}
      </div>
      <div style={divStyle}>{getLabel(listing.status)}</div>
      <div style={divStyle}>{listing.type}</div>
      <div style={divStyle}>{listing.dom}</div>
      <div style={divStyle}>{getAvailability(listing.availability)}</div>
      <div style={divStyle}>{expiry}</div>
      <div style={divStyle}>
        {listing.agents.map((agent, index) => (
          <div key={index} style={{ ...wrapTextStyles }}>
            {agent}
          </div>
        ))}
      </div>
    </div>
  );
}

function ListingComponent(props: { listings: Listing[] }) {
  const { getLabel } = React.useContext(ListingLabelContext);

  const { listings } = props;
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '4fr 3fr 3.5fr 2.5fr 2fr 1.5fr 3fr 3fr 3fr',
    gridColumnGap: '1em',
    paddingBottom: '0.1in',
    paddingTop: '0.1in',
    justifyItems: 'start',
    alignItems: 'start',
    overflow: 'wrap',
    minWidth: '100%',
    maxWidth: '100%',
  };
  const divStyle = { minWidth: '100%', maxWidth: '100%' };
  const divHeaderStyle = {
    minWidth: '100%',
    maxWidth: '100%',
    fontWeight: 900,
  };
  return (
    <GridContainer>
      <div className="content-block" style={gridStyle}>
        <div style={divHeaderStyle}>Address</div>
        <div style={divHeaderStyle}>
          <b>Price</b>
        </div>
        <div style={divHeaderStyle}>
          <b>{getLabel('Neighborhood')}</b>
        </div>
        <div style={divHeaderStyle}>{getLabel('Status')}</div>
        <div style={divHeaderStyle}>Type</div>
        <div style={divHeaderStyle}>DOM</div>
        <div style={divHeaderStyle}>{getLabel('Availability', 'Avail.')}</div>
        <div style={divHeaderStyle}>Expiry</div>
        <div style={divHeaderStyle}>Agents</div>
      </div>
      {listings.map(l => SingleListing(l, gridStyle, divStyle))}
    </GridContainer>
  );
}

const GridContainer = styled.div`
  overflow-wrap: break-word;
`;

export { Listing, ListingComponent };
